import React from "react";
import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export default function PurchaseOrderHeader({ onNewOrder }) {
  return (
    <Box sx={{ bgcolor: "#fff", borderBottom: "1px solid #e0e0e0", p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              bgcolor: "#ff9800",
              mr: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <ShoppingCartIcon sx={{ fontSize: "1.8rem", color: "white" }} />
          </Box>
          <Box>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: "#424242", mb: 0.5 }}>
              Pedidos de Compra
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Gerencie seus pedidos de compra
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onNewOrder}
          disabled
          sx={{
            bgcolor: "#ff9800",
            "&:hover": { bgcolor: "#f57c00" },
            borderRadius: 2,
            px: 3
          }}
        >
          Novo Pedido
        </Button>
      </Box>
    </Box>
  );
}